exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".OD0V{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "OD0V",
	"root": "OD0V"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./components/Video/Video.css
// module id = 187
// module chunks = 0